import React, { Component } from 'react';

import Datos from './Datos.jsx';
import DatosIntegrante from './DatosIntegrante.jsx';

class RowIntegrante extends Component {
    constructor(props) {
        super(props);
        
    }

    componentDidUpdate() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    render() {
        
        let {integrante, permisoModificacion, permisos} = this.props;
        
        let claseRow = "";
        let estadoAMostrar="";
        let claseEstado="";
        
        if(integrante.VinculoTarjeta == "Titular") claseRow = "tablaIntegrantesCuentaTitular";
        if(integrante.lastRow) claseRow += " tablaIntegrantesCuentaLastRow";

        switch(integrante.TarjetaCreditoEstadoId){
            case 1:
                estadoAMostrar = "SOLICITADA"
                claseEstado= " etiquetaCelesteHeader"
            break;
            case 3:
                estadoAMostrar = integrante.FechaHabilitacion ? "OPERATIVA" : "PEND. HAB."
                claseEstado = " etiquetaCelesteHeader"
            break;
            case 4:
                estadoAMostrar = "BLOQUEADA"
                claseEstado = " etiquetaCelesteHeader"
            break;
            case 6:
                estadoAMostrar = "DADA DE BAJA"
                claseEstado= " etiquetaCelesteHeader"
            break;            
        }
               
        if(integrante.firstRow){
            return (
                <tr className={claseRow}>   
                    <td><div>{integrante.NombreCliente}</div></td>
                    <td className='separadorGris'></td>
                    <td className='separadorGris'></td>
                    <td className='separadorGris'></td>
                    <td className='separadorGris'></td>
                    <td>
                        <div className='accionesIntegrantesCuentaNombre2'>
                            {permisos && permisos.permisoModificacionIntegrantes && <div onClick={()=>this.props.verDatosIntegrante(integrante.ClienteId)} className={'icono-lapiz-cta ' + (this.props.viendoIntegrante ? "topUpperXs":"clickable")}></div>}
                            {permisos && permisos.permisoReimpresionTarjeta && <div onClick={()=>this.props.actions.modalSeccion("IntegrantesCuenta","REIMPRESION-TARJETA",true,integrante,"tarjetaReimpresion")} data-title={"Reimpresión de tarjeta"}  data-toggle="tooltip" key={"icon-reimpresion-"+ integrante.EstadoTarjeta} className='icono-imprimir-cta accionesIntegrantesIconosAcciones clickable'></div>}
                        </div>
                    </td>
                </tr>
            );
        }else if(integrante.rowModificacion){
            return (
                <tr>
                    <td colSpan={6} className='div-padding-0'><div className="contenedorInfoTarjetaIndividual"> <Datos integrante={integrante}/></div></td>
                </tr>
            )
        }else if(integrante.rowModificacionIntegrante){
            return (
                <tr>
                    <td colSpan={6} className='div-padding-0'><div className="contenedorIntegranteIndividual"> <DatosIntegrante permisos={permisos} novedades={this.props.novedades} actions={this.props.actions} data={this.props.data} verDatosIntegrante={this.props.verDatosIntegrante} integrante={integrante}/></div></td>
                </tr>
            )
        }else{
            return (
                <tr className={claseRow}>
                    <td></td>
                    <td>{integrante.NumeroTarjeta}</td>
                    <td>{integrante.TipoTarjeta}</td>
                    <td></td>
                    <td className='div-padding-0'><label className={claseEstado}>{estadoAMostrar}</label></td>
                    <td>
                        <div className='accionesIntegrantesCuentaNombre'>
                            <div className="contenedor-acciones-integrante">
                                {permisos && permisos.permisoHabilitacionTarjeta && integrante.TarjetaCreditoEstadoId == 1 && <div onClick={()=>this.props.actions.modalSeccion("IntegrantesCuenta","HABILITACION-TARJETA",true,integrante,"tarjetaHabilitacion")} data-title={"Habilitación de Tarjeta"} data-toggle="tooltip" key={"icon-switch-"+ integrante.EstadoTarjeta} className='icono-switch clickable'></div>}
                                {permisos && permisos.permisoBlanqueoPINTarjeta && integrante.TarjetaCreditoEstadoId == 3 && <div onClick={()=>this.props.actions.modalSeccion("IntegrantesCuenta","BLANQUEO-TARJETA",true,integrante,"tarjetaBlanqueo")} data-title={"Blanqueo de PIN"} data-toggle="tooltip" key={"icon-blanqueo-"+ integrante.EstadoTarjeta} className='icono-blanqueo-pin clickable'></div>}
                                {permisos && permisos.permisoBloqueoTarjeta &&  integrante.TarjetaCreditoEstadoId == 3 && <div onClick={()=>this.props.actions.modalSeccion("IntegrantesCuenta","CONFIRMADOR-BLOQUEO",true,integrante,"tarjetaBloqueo")} data-title={"Bloqueo de Tarjeta"}  data-toggle="tooltip" key={"icon-unlock-"+ integrante.EstadoTarjeta} className='icono-unlock-cta accionesIntegrantesIconosAcciones clickable'></div>}
                                {permisos && permisos.permisoBloqueoTarjeta && integrante.TarjetaCreditoEstadoId == 4 && <div onClick={()=>this.props.actions.modalSeccion("IntegrantesCuenta","CONFIRMADOR-BLOQUEO",true,integrante,"tarjetaBloqueo")} data-title={"Desbloqueo de Tarjeta"}  data-toggle="tooltip" key={"icon-unlock-"+ integrante.EstadoTarjeta} className='icono-unlock-cta accionesIntegrantesIconosAcciones clickable'></div>}
                                {permisos && permisos.permisoDenunciaTarjeta && <div onClick={()=>this.props.actions.modalSeccion("IntegrantesCuenta","DENUNCIA-TARJETA",true,integrante,"tarjetaDenuncia")} data-title={"Denuncia de Tarjeta"}  data-toggle="tooltip" key={"icon-denuncia-"+ integrante.EstadoTarjeta} className='icono-alert-cta accionesIntegrantesIconosAcciones clickable'></div>}
                            </div>                            
                            {this.props.flechaArriba ? <div onClick={()=>this.props.verDatosTarjeta(null)} className='menu-desplegableMovimientos seccionRenglonesModelo__renglonModelo__trianguloUp seccionRenglonesModelo__renglonModelo__trianguloUp--activo accionesIntegrantesIconosAcciones clickable'></div> : <div onClick={()=>this.props.verDatosTarjeta(integrante.TarjetaCreditoId)} className='menu-desplegableMovimientos seccionRenglonesModelo__renglonModelo__trianguloDown accionesIntegrantesIconosAcciones'></div>}
                        </div>
                    </td>
                </tr>
            );
        }
    }
}

export default RowIntegrante;

